<action class="no-wrap button-2"
        [class.is-disabled]="disabled"
        cy-listingQuickAdd
        [status]="status"
        (click)="add()">
    <span class="inline-flex flex-middle">
        <i class="icon-plus m-r-1"
           [style.font-size.px]="15"
           [style.line-height]="0"></i>{{'Add' | translate}}
    </span>
</action>
<result [status]="status"
        *ifBrowser />